import { Seo } from "@/components/seo";
import { NewPasswordForm } from "@/features/reset-password/components/new-password.form";

export function SetNewPassword() {
  return (
    <div className="px-4 sm:px-6">
      <Seo title="Set New Password" />

      <p className="text-lg font-medium text-foreground">Set New Password</p>
      <p className="mb-6 text-base font-normal text-muted">
        Set a new password for your account
      </p>
      <div className="mb-8 sm:mb-11">
        <NewPasswordForm />
      </div>
    </div>
  );
}
